import * as $ from "jquery";
import {fillFormInputs, handleApiForm} from "../../forms";
import {closeModal, openModal, url} from "../../utilities";
import {toastAlert} from "../../toastAlert";
import {confirmModal} from "../../confirmModal";
import axios from "axios";

export const inventories_page = () => {
    const body = $('body');

    /// Tables
    const dictionariesTable = $('#dictionariesTable').DataTable();
    const dictionaryEntriesTable = $("#dictionaryEntriesTable").DataTable();
    const animalsTable = $("#animalsTable").DataTable();

    /// Forms
    // Add dictionary
    handleApiForm('#addDictionary', ({response, form}) => {
        if (response.data.code === 200) {
            closeModal('#addDictionaryModal');
            fillFormInputs(form, {
                name: '',
                description: '',
                order: ''
            })

            let dictionary = response.data.dictionary;
            let row = $(`
                <tr data-id="${dictionary.id}">
                    <td class="dictionary-order">${dictionary.order}</td>
                    <td class="dictionary-name">${dictionary.name}</td>
                    <td class="dictionary-description">${dictionary.description}</td>
                    <td class="entries-count">0</td>
                    <td>
                        <button data-entries="[]" data-id="${dictionary.id}" type="button" class="btn btn-sm btn-primary btnEditDictionary">
                            Edytuj
                        </button>
                        <button data-id="${dictionary.id}" type="button" class="btn btn-sm btn-danger btnDeleteDictionary">
                            Usuń
                        </button>
                    </td>
                </tr>
            `)

            dictionariesTable.api().rows.add(row);

            // update orders
            for (let orderData of response.data.newOrders) {
                let row = dictionariesTable.$(`tr[data-id=${orderData.id}]`)
                row.find('.dictionary-order').text(orderData.order);
                dictionariesTable.api().row(row).invalidate();
            }
            dictionariesTable.api().draw();

            toastAlert('Pomyślnie dodano nowy słownik cech');

            window.location.reload();
        }
    })

    // Edit dictionary
    handleApiForm('#editDictionary', ({response, form}) => {
        if (response.data.code === 200) {
            closeModal('#editDictionaryModal');
            fillFormInputs(form, {
                name: '',
                description: '',
                order: ''
            })

            let dictionary = response.data.dictionary;
            let row = dictionariesTable.$(`tr[data-id=${dictionary.id}]`)

            row.find('.dictionary-order').text(dictionary.order);
            row.find('.dictionary-name').text(dictionary.name);
            row.find('.dictionary-description').text(dictionary.description);
            dictionariesTable.api().row(row).invalidate();

            // update orders
            for (let orderData of response.data.newOrders) {
                let row = dictionariesTable.$(`tr[data-id=${orderData.id}]`)
                row.find('.dictionary-order').text(orderData.order);
                dictionariesTable.api().row(row).invalidate();
            }
            dictionariesTable.api().draw();

            toastAlert('Pomyślnie edytowano słownik cech');

            window.location.reload();
        }
    })

    // Add dictionary entry
    handleApiForm('#addDictionaryEntry', ({response, form}) => {
        if (response.data.code === 200) {
            closeModal('#addDictionaryEntryModal');
            fillFormInputs(form, {
                name: '',
            })

            let entries = response.data.entries;
            let row = dictionariesTable.$(`tr[data-id="${response.data.inventory_dictionary_id}"]`);
            row.find(`button[data-entries]`).data('entries', entries)
            row.find(`.entries-count`).text(entries.length)
            dictionariesTable.api().row(row).invalidate();
            dictionariesTable.api().draw();

            reloadEntries(response.data.inventory_dictionary_id)
            toastAlert('Pomyślnie dodano nową opcję do słownika szczegółów');
        }
    })

    // Edit dictionary entry
    handleApiForm('#editDictionaryEntry', ({response, form}) => {
        if (response.data.code === 200) {
            closeModal('#editDictionaryEntryModal');
            fillFormInputs(form, {
                name: '',
            })

            let entries = response.data.entries;
            let row = dictionariesTable.$(`tr[data-id="${response.data.inventory_dictionary_id}"]`)
            row.find(`button[data-entries]`).data('entries', entries)
            dictionariesTable.api().row(row).invalidate();

            reloadEntries(response.data.inventory_dictionary_id)
            toastAlert('Pomyślnie edytowano opcję słownika szczegółów');
        }
    })

    // Edit animal type order
    handleApiForm('#editInventoryAnimalTypeOrderForm', ({response, form}) => {
        if (response.data.code === 200) {
            closeModal('#animalTypeChangeOrderModal');
            fillFormInputs(form, {
                order: '',
            })

            toastAlert('Pomyślnie zmieniono kolejność gatunków');

            /// UPDATE FRONT-END ORDER
            let tbody = $('#inventoryAnimalTypesTable tbody');
            let rows = tbody.find('tr');

            $(rows).each(function() {
                let newOrderElement = response.data.newOrders.find(el => parseInt(el.id) === parseInt($(this).data('id')));
                if(!newOrderElement) {
                    return;
                }

                let newOrder = newOrderElement.order;
                $(this).attr('data-order', newOrder);
                $(this).find('.animalTypeOrder').text(newOrder);
                $(this).find('.btnEditAnimalTypeOrder').attr('data-order', newOrder);
            })

            rows = rows.sort(function(a, b) {
                let aOrder = parseInt($(a).data('order'));
                let bOrder = parseInt($(b).data('order'));

                if(aOrder > bOrder) {
                    return 1;
                }

                if(bOrder > aOrder) {
                    return -1;
                }

                let aCounter = parseInt($(a).data('counter'));
                let bCounter = parseInt($(b).data('counter'));

                if(aCounter > bCounter) {
                    return 1;
                }

                if(bCounter > aCounter) {
                    return -1;
                }

                return 0;
            });

            tbody.empty();
            tbody.append(rows);
        }
    })

    /// Animals
    // Add animal
    handleApiForm('#addInventoryAnimal', ({response, form}) => {
        if (response.data.code === 200) {
            closeModal('#addAnimalModal');
            fillFormInputs(form, {
                name: '',
            })

            let animal = response.data.animal;
            let row = $(`
                <tr data-id="${animal.id}">
                    <td class="animal-name">${animal.name}</td>
                    <td>
                        <button data-id="${animal.id}" type="button" class="btn btn-sm btn-primary btnEditAnimal">
                            Edytuj
                        </button>
                        <button data-id="${animal.id}" type="button" class="btn btn-sm btn-danger btnDeleteAnimal">
                            Usuń
                        </button>
                    </td>
                </tr>
            `)

            animalsTable.api().rows.add(row).draw();
            toastAlert('Pomyślnie dodano nową zwierzynę');
        }
    })

    // Edit animal
    handleApiForm('#editInventoryAnimal', ({response, form}) => {
        if (response.data.code === 200) {
            closeModal('#editAnimalModal');
            fillFormInputs(form, {
                name: ''
            })

            let animal = response.data.animal;
            let row = animalsTable.$(`tr[data-id=${animal.id}]`)

            row.find('.animal-name').text(animal.name);
            animalsTable.api().row(row).invalidate();

            toastAlert('Pomyślnie edytowano zwierzynę');
        }
    })

    const reloadEntries = (inventory_dictionary_id) => {
        let entries = dictionariesTable.$(`tr[data-id="${inventory_dictionary_id}"]`).find(`button[data-entries]`).data('entries');
        dictionaryEntriesTable.api().clear()
        if (entries.length === 0) {
            dictionaryEntriesTable.api().draw()
            return;
        }

        for (let entry of entries) {
            dictionaryEntriesTable.api().rows.add($(`
                <tr>
                    <td>${entry.order}</td>
                    <td>${entry.name}</td>
                    <td>
                        <button data-order="${entry.order}" data-name="${entry.name}" data-id="${entry.id}" class="btn btn-sm btn-primary btnEditEntry" type="button">Edytuj</button>
                        <button data-id="${entry.id}" class="btn btn-sm btn-danger btnDeleteEntry" type="button">Usuń</button>
                    </td>
                </tr>
            `))
        }

        dictionaryEntriesTable.api().draw();
    }

    body.on('click', '.btnDeleteEntry', async function () {
        let confirm = await confirmModal('Czy jesteś pewny/a, że chcesz usunąć opcję słownika szczegółów?', {color: 'danger'});
        if (!confirm) return;

        try {
            const response = await axios.post(url(`api/admin/inventories/templates/dictionaries/entries/${$(this).data('id')}/delete`));

            if (response.data.code !== 200) {
                throw new Error();
            }

            let entries = response.data.entries;
            let row = dictionariesTable.$(`tr[data-id="${response.data.inventory_dictionary_id}"]`);
            row.find(`button[data-entries]`).data('entries', entries)
            row.find(`.entries-count`).text(entries.length)
            dictionariesTable.api().row(row).invalidate();
            reloadEntries(response.data.inventory_dictionary_id)

            toastAlert('Pomyślnie usunięto opcję');
        } catch (err) {
            toastAlert('Wystąpił błąd podczas próby usunięcia opcji', {type: 'danger'})
        }
    })

    body.on('click', '.btnEditEntry', async function () {
        openModal('#editDictionaryEntryModal')
        $("#editDictionaryEntry input[name='name']").val($(this).data('name'))
        $("#editDictionaryEntry input[name='order']").val($(this).data('order'))
        $("#editDictionaryEntry").attr('action', window._API_EDIT_ENTRIES_URL.replace('REPLACE_ID', $(this).data('id')))
    })

    $('.btnAddDictionaryEntry').click(function () {
        let modal = $("#addDictionaryEntryModal")
        openModal(modal);

        $("#addDictionaryEntry").attr('action', window._API_ENTRIES_URL.replace('REPLACE_ID', $(this).data('inventory_dictionary_id')))
    })

    body.on('click', '.btnEditAnimalTypeOrder', async function () {
        openModal('#animalTypeChangeOrderModal')
        $("#editInventoryAnimalTypeOrderForm input[name='order']").val($(this).data('order'))
        $("#editInventoryAnimalTypeOrderForm").attr('action', window._API_EDIT_ANIMAL_TYPE_ORDER_URL.replace('REPLACE_ID', $(this).data('id')))
    })

    body.on('click', '.btnDeleteDictionary', async function () {
        let confirm = await confirmModal('Czy jesteś pewny/a, że chcesz usunąć ten słownik cech?', {color: 'danger'});
        if (!confirm) return;

        try {
            const response = await axios.post(url(`api/admin/inventories/templates/dictionaries/${$(this).data('id')}/delete`));

            if (response.data.code !== 200) {
                throw new Error();
            }

            let row = dictionariesTable.$(`tr[data-id=${$(this).data('id')}]`)
            dictionariesTable.api().row(row).remove().draw();

            toastAlert('Pomyślnie usunięto słownik');
            window.location.reload();
        } catch (err) {
            toastAlert('Wystąpił błąd podczas próby usunięcia słownika', {type: 'danger'})
        }
    })

    body.on('click', '.btnEditDictionary', function () {
        let modal = $("#editDictionaryModal")
        openModal(modal);

        let row = dictionariesTable.$(`tr[data-id=${$(this).data('id')}]`)

        modal.find(`input[name="name"]`).val(row.find('.dictionary-name').text());
        modal.find(`input[name="order"]`).val(row.find('.dictionary-order').text());
        modal.find(`textarea[name="description"]`).val(row.find('.dictionary-description').data('content'));
        $("#editDictionary").attr('action', window._API_EDIT_DICTIONARY_URL.replace('REPLACE_ID', $(this).data('id')))

        reloadEntries($(this).data('id'));

        $('.dictionary-name-placeholder').text($(this).data('name'));
        $('.btnAddDictionaryEntry').data('inventory_dictionary_id', $(this).data('id'))
    })

    body.on('click', '.btnAssignToAll', async function () {
        let confirm = await confirmModal('Czy na pewno chcesz przypisać słownik do wszystkich gatunków?');
        if (!confirm) return;

        try {
            const response = await axios.post($(this).data('url'));

            if (response.data.code !== 200) {
                throw new Error();
            }

            toastAlert('Pomyślnie przypisano słownik do wszystkich gatunków');

            body.find('.dictionaryCheckbox[data-id="'+ response.data.id +'"]').prop('checked', true)
        } catch (err) {
            toastAlert('Wystąpił błąd podczas próby przypisania słownika do wszystkich gatunków', {type: 'danger'})
        }
    })

    body.on('click', '.btnRemoveFromAll', async function () {
        let confirm = await confirmModal('Czy na pewno chcesz usunąć słownik z wszystkich gatunków?');
        if (!confirm) return;

        try {
            const response = await axios.post($(this).data('url'));

            if (response.data.code !== 200) {
                throw new Error();
            }

            toastAlert('Pomyślnie usunięto słownik z wszystkich gatunków');

            body.find('.dictionaryCheckbox[data-id="'+ response.data.id +'"]').prop('checked', false)
        } catch (err) {
            toastAlert('Wystąpił błąd podczas próby usunięcia słownika z wszystkich gatunków', {type: 'danger'})
        }
    })

    body.on('click', '.btnArchive', async function () {
        let confirm = await confirmModal('Czy na pewno chcesz archiwizować ten szablon? Nowe inwentaryzacje nie będą mogły korzystać z tego szablonu.', {color: 'warning'});
        if (!confirm) return;

        try {
            const response = await axios.post(url(`api/admin/inventories/templates/${$(this).data('id')}/archive`));

            if (response.data.code !== 200) {
                throw new Error();
            }

            window.location.reload();
        } catch (err) {
            toastAlert('Wystąpił błąd podczas próby archiwizacji szablonu', {type: 'danger'})
        }
    })

    /// Animals

    body.on('click', '.btnEditAnimal', function () {
        let modal = $("#editAnimalModal")
        openModal(modal);

        let row = animalsTable.$(`tr[data-id=${$(this).data('id')}]`)

        modal.find(`input[name="name"]`).val(row.find('.animal-name').text());
        $("#editInventoryAnimal").attr('action', window._API_EDIT_ANIMAL_URL.replace('REPLACE_ID', $(this).data('id')))
    })

    body.on('click', '.btnDeleteAnimal', async function () {
        let confirm = await confirmModal('Czy jesteś pewny/a, że chcesz usunąć tą zwierzynę?', {color: 'danger'});
        if (!confirm) return;

        try {
            let url = window._API_DELETE_ANIMAL_URL.replace('REPLACE_ID', $(this).data('id'));
            const response = await axios.post(url);

            if (response.data.code !== 200) {
                let err = new Error(response.data.error);
                err.code = response.data.code;

                throw err;
            }

            let row = animalsTable.$(`tr[data-id=${$(this).data('id')}]`)
            animalsTable.api().row(row).remove().draw();

            toastAlert('Pomyślnie usunięto zwierzynę');
        } catch (err) {
            if(err.code === 400) {
                toastAlert(err.message, {type: 'danger'})
                return;
            }

            toastAlert('Wystąpił błąd podczas próby usunięcia obszaru', {type: 'danger'})
        }
    })
}
